import { Box, CardMedia, styled } from "@mui/material";
import React from "react";
import Slider from "react-slick"; 
const VITE_UPLOAD_MYVIDEO__URL = import.meta.env.VITE_UPLOAD_MYVIDEO__URL;

interface CenterModeProps {
  videos: Array<{ id: number; src: string, poster:string }>; 
  selectedReel:any;
  handleVideoClick2: (index: number) => void;
}

  const SliderContainer = styled(Box)(({ theme }) => ({
    width: '100%',
    padding: theme.spacing(2),
  }));

const CenterModeReelVideo: React.FC<CenterModeProps> = ({ videos, selectedReel, handleVideoClick2 }) => {
    const settings = {
        className: 'center',
        centerMode: true,
        infinite: false,
        centerPadding: '60px',
        slidesToShow: 1,
        speed: 500,
      };

  return (
    <SliderContainer className="mob_slick_slider">
      <Slider {...settings}>
        {videos.map((video, index) => (
          <CardMedia
            key={video.id}
            component="img"
            image={VITE_UPLOAD_MYVIDEO__URL + video.poster}
            alt={`Image ${video.id}`}
            sx={{
              width: "100%",
              objectFit: "cover",
              cursor: "pointer",
              filter: selectedReel === index ? "brightness(50%)" : "none", // Dull background for selected image
            }}
            onClick={() => handleVideoClick2(index)} // Trigger image click
          />
        ))}
      </Slider>
    </SliderContainer>
  );
};

export default CenterModeReelVideo;
